<template>
  <Page>
    <h1>GY.I.K.</h1>

  <h3>Most mi ez?</h3>
  <p>Gondokozol rajta, hogy bedobtok egy sört a haverokkal, de nincs ma senkinek szülinapja? Régóta őrzöl egy doboz sört a hűtő aljában, mert nem volt megfelelő alkalom? Valamilyen ürügy kell, hogy elhívd a csoporttársadat az esti kocsmázásra?</p>
  <p>Mi segítünk neked!</p>
  <h3>És ingyen van?</h3>
  <p>Igen.</p>
  <h3>És kapok sört?</h3>
  <p>Igen. Ha találkozunk, akkor meghívlak egy sörre.</p>
  <h3>Na jó, ez így tetszik nekem.</h3>
  <p>Örülünk neki.</p>
  <h3>De többször dobta ki nekem ugyanazt!</h3>
  <p>Sajnos ez könnyen előfordulhat, hiszen véges számú okok közül választ ki egyet véletlenszerűen a program, &nbsp;ha a gombra nyomsz. De van egy jó hírem: te is tudsz okokat mondani! Csak küldd el az <a title="info@mireigyunkma.hu" href="mailto:info@mireigyunkma.hu" target="_blank">info@mireigyunkma.hu</a> e-mail címre, vagy írd ki a <a title="facebook.com/mireigyunkma" href="http://facebook.com/mireigyunkma" target="_blank">facebook.com/mireigyunkma</a> oldalon! Ha nem pusztalatosan rossz vagy kínosan erőltetett, akkor biztosan hamar bekerül. Ha meg az, akkor kis eséllyel, a szerkesztők fura kis humorától függően.</p>
  </Page>
</template>
<script>
  import Page from '../components/Page';
  export default {
    components: {Page},
  };
</script>
